function toSnakeCase(str) {
    return str
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2") // camelCase & PascalCase → snake_case
        .replace(/[\s-]+/g, "_") // Spaces & hyphens → underscores
        .toLowerCase();
}
export default toSnakeCase;
